import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';

import { Wrapper as Accordion } from '../Accordion/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${props => props.theme.gap(2, 'column')};

  ${Accordion} {
    background: none;
    border-radius: 0;
    padding-bottom: ${props => props.theme.space(2)};

    &:not(:last-child) {
      border-bottom: 1px solid #e5e5e5;
    }

    ${mediaMin.smallBreakpoint`
      width: 100%;
    `}
  }

  ${mediaMin.smallBreakpoint`
    align-items: center;
  `}
`;

export const Title = styled.span`
  font-family: 'IntervalNextReg', sans-serif;
  font-size: ${props => props.theme.rem(22)};
  line-height: ${props => props.theme.rem(26)};
  font-weight: 600;
  margin-bottom: ${props => props.theme.space(5)};
  color: ${props => props.theme.colors.blueDianne};

  ${mediaMin.smallBreakpoint`
    font-size: ${props => props.theme.rem(18)};
  `}
`;
